import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <header className="bg-white border-b border-background-200 sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-foreground-600 hover:text-foreground-900 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            뒤로 가기
          </button>
          <h1 className="text-sm font-semibold text-foreground-950">이용약관</h1>
          <div className="w-20" />
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <div className="bg-white rounded-xl border border-background-200 p-6 md:p-8">
          <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-2">이용약관</h1>
          <p className="text-xs text-foreground-500 mb-8">시행일: 2026년 1월 1일</p>

          <div className="space-y-8 text-sm text-foreground-700 leading-relaxed">
            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제1조 (목적)</h2>
              <p>
                본 약관은 MC에듀(이하 "회사")가 제공하는 교육 진단 및 진로·학습 분석 서비스(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제2조 (용어의 정의)</h2>
              <ul className="space-y-2 list-disc pl-5">
                <li>"회원"이란 본 약관에 동의하고 회사가 정한 절차에 따라 가입하여 서비스를 이용하는 자를 말합니다.</li>
                <li>"일반회원"이란 개인 이용자로서 유료 이용권을 구매하여 서비스를 이용하는 회원을 말합니다.</li>
                <li>"학원장 회원"이란 학원을 운영하며 학원 단위 이용권을 구매하여 학생을 관리하는 회원을 말합니다.</li>
                <li>"학생 회원"이란 학원장 회원의 승인을 통해 소속 학원의 관리 하에 서비스를 이용하는 회원을 말합니다.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제3조 (서비스의 내용)</h2>
              <p>회사는 회원에게 다음과 같은 서비스를 제공합니다.</p>
              <ul className="space-y-1.5 list-disc pl-5 mt-2">
                <li>계열·진로·전공·직업 탐색 검사</li>
                <li>고등학교 선택과목 추천</li>
                <li>성격·성향 기반 공부법 검사</li>
                <li>종합 인지능력(IQ) 검사</li>
                <li>어휘력·문해력 검사</li>
                <li>검사 결과 저장 및 결과지 인쇄</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제4조 (이용권 및 결제)</h2>
              <ul className="space-y-2 list-disc pl-5">
                <li>일반회원과 학원장 회원은 유료 이용권을 구매하여 서비스를 이용합니다.</li>
                <li>이용권은 계좌이체로 결제하며, 가입 시 입력한 실명과 입금자명이 일치해야 승인이 처리됩니다.</li>
                <li>가입 승인은 입금 확인 후 24시간 이내에 처리됩니다.</li>
                <li>이용권의 종류와 가격은 서비스 내 공지에 따릅니다.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제5조 (환불정책)</h2>
              <ul className="space-y-2 list-disc pl-5">
                <li>본 이용권은 디지털 콘텐츠(온라인 서비스)로, 전자상거래 등에서의 소비자보호에 관한 법률 및 소비자분쟁해결기준에 따라 환불이 처리됩니다.</li>
                <li>1개월 이용권은 결제 즉시 환불이 불가합니다.</li>
                <li>3개월·1년 이용권은 환불 신청 시 1개월 이용금액을 공제하고 나머지 금액만 환불됩니다.</li>
                <li>입금 후 운영자 승인(활성화) 전에는 전액 환불됩니다.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제6조 (검사 결과의 성격)</h2>
              <p>
                본 서비스에서 제공하는 검사 결과는 교육적 참고 목적의 진단 자료로, 공개된 교육자료를 기반으로 산출됩니다. IQ 검사 등 일부 검사는 추정치로 정식 심리·지능검사를 대체할 수 없으며, 중요한 진로·교육 결정 시에는 전문가의 상담을 권장합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제7조 (회원의 의무)</h2>
              <ul className="space-y-2 list-disc pl-5">
                <li>회원은 본인 정보를 정확하게 입력해야 하며, 타인의 정보를 도용하여 가입할 수 없습니다.</li>
                <li>회원은 서비스 이용 시 관계 법령과 본 약관을 준수해야 합니다.</li>
                <li>회원은 서비스의 정상적인 운영을 방해하는 행위를 해서는 안 됩니다.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제8조 (서비스의 중단)</h2>
              <p>
                회사는 시스템 점검, 설비 장애, 천재지변 등 부득이한 사유가 있는 경우 서비스를 일시적으로 중단할 수 있으며, 이 경우 사전 또는 사후에 공지합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제9조 (약관의 변경)</h2>
              <p>
                회사는 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있으며, 개정 시 적용일자와 개정 내용을 서비스 내에 공지합니다.
              </p>
            </section>

            <section>
              <h2 className="text-base font-bold text-foreground-950 mb-2">제10조 (준거법 및 관할)</h2>
              <p>
                본 약관과 관련한 분쟁은 대한민국 법령을 준거법으로 하며, 관할 법원은 민사소송법에서 정한 바에 따릅니다.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}